import { render } from "./bundles.vue?vue&type=template&id=dec52a1e&scoped=true"
import script from "./bundles.vue?vue&type=script&lang=js"
export * from "./bundles.vue?vue&type=script&lang=js"

import "./bundles.vue?vue&type=style&index=0&id=dec52a1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dec52a1e"]])

export default __exports__